<template>
  <section
    v-if="!areFiveCardHandPercentagesUpToDate && textWhenFiveCardHandPercentagesArentUpToDate"
    class="five-card-hands-section-alerts bg-warning"
  >
    {{ textWhenFiveCardHandPercentagesArentUpToDate }}
  </section>
</template>

<script>
export default {
  name: 'five-card-hands-section-alerts',
  props: [
    'textWhenFiveCardHandPercentagesArentUpToDate',
    'areFiveCardHandPercentagesUpToDate',
  ],
};
</script>

<style lang="scss" scoped>
  .bg-warning {
    padding: 10px;
    margin-top: 10px;
    margin-bottom: 0;
  }
</style>



// WEBPACK FOOTER //
// src/components/five-card-hands-section/alerts.vue